module.exports = __webpack_public_path__ + "img/lottery_icon.ca42af49.svg";